<template>
  <div v-if="!isLoading" id="g-contents" class="kbo player-wrap">
    <baseball-result-player :vs-score-result="vsScoreResult" :game-id="gameId" :content-id="contentId"></baseball-result-player>
    <game-result :vs-score-result="vsScoreResult" :inning-result-list="inningResultList"></game-result>
    <game-important-information :game-summary="gameSummary" :vs-score-result="vsScoreResult"></game-important-information>
    <team-batter-and-pitcher-records :vs-score-result="vsScoreResult" :player-status="playerStatus"></team-batter-and-pitcher-records>
  </div>
</template>

<script>
  import BaseballResultPlayer from '@/components/player/baseball/BaseballResultPlayer'
  import GameResult from '@/components/kbo/GameResult'
  import GameImportantInformation from '@/components/kbo/GameImportantInformation'
  import TeamBatterAndPitcherRecords from '@/components/kbo/TeamBatterAndPitcherRecords'
  import { getGameRecord, getHighlightContents } from '@/common/utils/request'
  import { destroyPlayer } from '@/common/utils/common'
  import { showLoginPopup } from '@/common/utils/player'
  import _ from 'lodash'
  import { setReferer } from '@/common/utils/referer'
  export default {
    name: 'index',
    components: {
      BaseballResultPlayer,
      GameResult,
      GameImportantInformation,
      TeamBatterAndPitcherRecords
    },
    data () {
      return {
        isLoading: true,
        gameId: '',
        inningResultList: [],
        gameSummary: {},
        vsScoreResult: {},
        playerStatus: [],
        contentId: ''
      }
    },
    methods: {
      async fetchData () {
        try {
          return await getGameRecord({ gameId: this.gameId })
        } catch (e) { console.log(e) }
      },
      async init () {
        setReferer(this.$route.fullPath)
        this.isLoading = true
        this.gameId = _.get(this.$route, 'query.game_id', '')
        await this.getContentId()
        const response = await this.fetchData()
        this.setData(response)
        this.isLoading = false
      },
      setData (response) {
        this.inningResultList = _.get(response, 'data.grids.0.INNING', [])
        this.vsScoreResult = _.get(response, 'data.grids.3.VSSCORERESULT.0', {})
        this.playerStatus = _.get(response, 'data.grids.2.PLAYERSTAT', [])
        this.gameSummary = _.get(response, 'data.grids.1.GAMESUMMARY.0', {})
      },
      setPlayerEvent () {
        window.showLoginLayout = showLoginPopup
      },
      async getContentId () {
        await getHighlightContents({ contentId: this.gameId }).then(({ data }) => {
          this.contentId = _.get(data, 'contentid', '')
          if (this.contentId !== '') this.setPlayerEvent()
        })
      }
    },
    created () {
      this.init()
    },
    beforeDestroy () {
      destroyPlayer()
    }
  }
</script>

<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/live.css"></style>
<style lang="css" src="@/assets/css/kbo.css"></style>
<style scoped>
  .kbo.player-wrap{
    padding-top: 40px;
  }
</style>
